import * as conf from "qpr-base/configuration";
import { getFileApiURL } from "qpr-base/utils/url-utils";
// import LanguageSwitchContainer from "qpr-base/viewcomponents/LanguageSwitchContainer/LanguageSwitchContainer";
// import { LanguageSwitch } from "qpr-base/viewcomponents/LanguageSwitch/LanguageSwitch";
import * as registry from "@qpr/client-api-registry";
import { ReactComponent as AttachmentPinIcon } from "assets/AttachmentPinIcon.svg";
import { ReactComponent as CloseButton } from "assets/Close.svg";
import { ReactComponent as Delete } from "assets/Delete.svg";
import { ReactComponent as PaperPlusIcon } from "assets/PaperPlus.svg";
import { ReactComponent as PdfIcon } from "assets/Pdf.svg";
import { ICardElementWithChildren } from "backend/model/model";
import Search from "components/Search";
import Breadcrumb from "components/toolbars/Breadcrumb";
import React from "react";
conf.System.query.enableChildCache = true;
conf.System.query.enableObjectCache = true;

conf.setMapQueryResults((row: ICardElementWithChildren) => {
  return row;
});

registry.addSvg({
  AttachmentPinIcon,
  PdfIcon,
  PaperPlusIcon,
  Delete,
  CloseButton,
});

conf.setIcon(
  "NotificationIcon",
  <img
    src={getFileApiURL("/icons/NotificationCenter.svg")}
    alt="Notifications"
  />
);
conf.setToolbar("SearchBar", Search);
conf.setToolbar("Breadcrumb", Breadcrumb);

conf.setToolbar("PlanSwitch", () => <div />);

conf.setToolbar("SearchBar", () => (
  <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
    <Search />
  </div>
));
